import React, { Component } from 'react';
import { APP_KEY, API_URL } from './../config';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { getToken } from './../Utils/Common';
import AppHeader from './Header/Header';
import AppSidebar from './Sidebar/Sidebar';
import AppFooter from './Footer/Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

const token = getToken();
const headers = { headers : { "app-key" : APP_KEY, "x-access-token" : token } }

class VehicleType extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.config = {}
        this.state = {
            loading : false,
            data : [],
            total : 0,
            page : 0,
            size : 10,
            search : "",
            columns : [{
                name: 'Name',
                selector: `name`,
            },{
                name: 'Max Delivery Area Radius',
                selector: 'max_delivery_area_radius',
            },{
                name: 'Max Pickup Area Radius',
                selector: 'max_pickup_area_radius',
            },{
                name: 'Action',
                cell: row => <><button className="btn btn-info" data-toggle="modal" data-target="#modal-default" onClick={this.getData.bind(this, row)}><i className="fa fa-pencil"></i></button>&nbsp;&nbsp;&nbsp;<button className="btn btn-danger" id={row._id} onClick={this.handleDelete.bind(this, row._id)}><i className="fa fa-trash-o"></i></button></>,
            }],
            is_update : false,
            edit_id : "",
            editData: {},
            fields: {},
            errors: {},
        }
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
    
        if (!fields["name"]) {
          formIsValid = false;
          errors["name"] = "This field is required";
        }    
        // if (typeof fields["name"] !== "undefined") {
        //   if (!fields["name"].match(/^[a-zA-Z]+$/)) {
        //     formIsValid = false;
        //     errors["name"] = "Please enter only letters";
        //   }
        // }

        if (!fields["max_delivery"]) {
            formIsValid = false;
            errors["max_delivery"] = "This field is required";
        }

        if (!fields["max_pickup"]) {
            formIsValid = false;
            errors["max_pickup"] = "This field is required";
        }
    
        this.setState({ errors: errors });
        return formIsValid;
      }

    handleDelete = async (id) => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
          })
          
          swalWithBootstrapButtons.fire({
            title: 'Are you sure?',
            text: "Once deleted, you will not be able to recover this record!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
                let url = API_URL+`/vehicle-type/deletevehicletype?id=${id}`;
                axios.delete(url, headers).then(res => {
                    if(res.data.success === true) {
                        toast.success(res.data.message);
                        this.getDataList();
                    } else {
                        toast.error(res.data.message);
                    }
                })
                swalWithBootstrapButtons.fire(
                    'Deleted!',
                    'Your record has been deleted.',
                    'success'
                )
            } else if (
              /* Read more about handling dismissals below */
              result.dismiss === Swal.DismissReason.cancel
            ) {
              swalWithBootstrapButtons.fire(
                'Cancelled',
                'Your record is safe',
                'error'
              )
            }
          });
    }

    handleSubmit(e) {
        e.preventDefault();  
        this.setState({ loading : true });  
        if (this.handleValidation()) {
            var data = {
                name : this.state.name,
                max_pickup : this.state.max_pickup,
                max_delivery : this.state.max_delivery,
            }

            axios.post(`${API_URL}/vehicle-type/vehicletypesave`, data, headers ).then(res => {
                if(res.data.success === true) {
                    this.handleReset();
                    this.getDataList();
                    toast.success(res.data.message);
                    this.myRef.current.click();
                } else {
                    toast.error(res.data.message);
                    this.setState({ loading : false });
                }
            }).catch(err => {
                console.log(err);
                this.setState({ loading : false });
            })
        } else {
            //   alert("Form has errors.");
            this.setState({ loading : false });
        }
    }

    handleUpdate(e) {
        e.preventDefault();    
        this.setState({ loading : true });
        if (this.handleValidation()) {
            var data = {
                name : this.state.name,
                max_pickup : this.state.max_pickup,
                max_delivery : this.state.max_delivery,
            }
            var id = this.state.edit_id;

            axios.put(`${API_URL}/vehicle-type/updatevehicletype?id=${id}`, data, headers ).then(res => {
                if(res.data.success === true) {                    
                    this.handleReset();
                    this.getDataList();
                    toast.success(res.data.message);
                    this.myRef.current.click();
                } else {
                    toast.error(res.data.message);
                    this.setState({ loading : false });
                }
            }).catch(err => {
                this.setState({ loading : false });
                console.log(err);
            })
        } else {
        //   alert("Form has errors.");
            this.setState({ loading : false });
        }
    }

    getData = async (data) => {
        // console.log(data)        
        let fields = this.state.fields;
        fields = {
            name : data.name,
            max_pickup : data.max_pickup_area_radius,
            max_delivery : data.max_delivery_area_radius,
        };

        await this.setState({
            is_update : true,
            edit_id : data._id,
            name : data.name,
            max_pickup : data.max_pickup_area_radius,
            max_delivery : data.max_delivery_area_radius,
            errors : {},
            fields
        });

        console.log(this.state);
    }
    
    handleReset = async (e) => {
        Array.from(document.querySelectorAll("input")).forEach(
            input => (input.value = "")
        );
        await this.setState({
            is_update : false,
            edit_id : "",
            name : "",
            max_pickup : "",
            max_delivery : "",
            fields : {},
            errors : {},
            loading : false
        });        
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name ] : e.target.value });
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({ fields, loading : false });        
    }

    handleSearch = async (e) => {
        await this.setState({ search : e.target.value });
        this.getDataList();
    }

    handlePage = async (page) => {
        await this.setState({ page : (page - 1)});
        this.getDataList();
    }

    getDataList = () => {
        let url = API_URL+`/vehicle-type/getallvehicletype?page=${this.state.page}&size=${this.state.size}&search=${this.state.search}`;
        axios.get(url, headers).then(res => {
            if(res.data.success === true) {
                // alert(res.data.data.totalDocs)
                this.setState({
                    total: res.data.data.totalDocs,
                    data: res.data.data.docs
                })
            }
        })
    }

    inputNumber = (event) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    }

    componentDidMount(){
        this.getDataList();
    }

    render() {
        return (<div>
            <ToastContainer />
            <AppHeader />
            <AppSidebar />  
            <div className="content-wrapper">
                <section className="content-header">
                <h1> Vehicle Type </h1>
                <ol className="breadcrumb">
                    <li><a href="/#"><i className="fa fa-dashboard"></i> Home</a></li>
                    <li className="active">Vehicle Type</li>
                </ol>
                </section>
        
                <section className="content">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="box">
                                <div className="box-header">
                                    <h3 className="box-title">Vehicle Type List</h3>
                                </div>
                                <div className="box-body">
                                    <DataTable
                                        title={<div id="example1_filter" className="dataTables_filter"><label><input type="text" className="form-control input-sm" placeholder="Search..." aria-controls="example1" onInput={this.handleSearch} /></label><button className="btn btn-success pull-right" data-toggle="modal" data-target="#modal-default" onClick={this.handleReset.bind(this)}>Add Vehicle Type</button></div>}
                                        columns={this.state.columns}
                                        data={this.state.data}
                                        highlightOnHover
                                        pagination
                                        paginationServer
                                        paginationTotalRows={this.state.total}
                                        paginationPerPage={this.state.size}
                                        paginationComponentOptions={{
                                            noRowsPerPage: true
                                        }}
                                        onChangePage={this.handlePage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Add Vehicle Type */}
                    <div className="modal fade" id="modal-default">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleReset.bind(this)} ref={this.myRef}>
                                    <span aria-hidden="true">&times;</span></button>
                                    <h4 className="modal-title">{(this.state.is_update) ? 'Edit' : 'Add'} Vehicle Type</h4>
                                </div>
                                <div className="modal-body">
                                    <div className="box">
                                        <div className="box-body">
                                            <div className="form-group">
                                                <label>Name <i className="text-red">*</i></label>
                                                <input type="text" name="name" id="name" className="form-control clear" placeholder="Enter Vehicle Type" onChange={this.handleChange} maxlength="30" value={(this.state.is_update) ? this.state.name : null} />
                                                <div className="text-red">{this.state.errors["name"]}</div>
                                            </div>
                                            <div className="form-group">
                                                <label>Max Delivery Area Radius (km) <i className="text-red">*</i></label>
                                                <input type="text" name="max_delivery" id="max_delivery" className="form-control clear" placeholder="Max Delivery Area Radius" maxlength="3" onChange={this.handleChange} onKeyPress={this.inputNumber} value={(this.state.is_update) ? this.state.max_delivery : null}/>
                                                <div className="text-red">{this.state.errors["max_delivery"]}</div>
                                            </div>
                                            <div className="form-group">
                                                <label>Max Pickup Area Radius (km) <i className="text-red">*</i></label>
                                                <input type="text" name="max_pickup" id="max_pickup" className="form-control clear" placeholder="Max Pickup Area Radius" maxlength="3" onChange={this.handleChange} onKeyPress={this.inputNumber} value={(this.state.is_update) ? this.state.max_pickup : null}/>
                                                <div className="text-red">{this.state.errors["max_pickup"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">                            
                                    <button type="button" className="btn btn-default" data-dismiss="modal" ref={this.myRef} onClick={this.handleReset.bind(this)} >Clear</button>
                                    {
                                        (this.state.is_update)
                                        ? <button type="button" className="btn btn-primary" onClick={this.handleUpdate.bind(this)} disabled={this.state.loading}>{this.state.loading ? 'Loading...' : 'Submit'}</button>
                                        : <button type="button" className="btn btn-primary" onClick={this.handleSubmit.bind(this)} disabled={this.state.loading}>{this.state.loading ? 'Loading...' : 'Save'}</button>
                                    }                                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <AppFooter />
          </div>);
    }
}

export default VehicleType;